<template>
  <div class="container">
    <Header activeIndex="0" />
    <div id="luxy">
      <div class="section01">
        <div class="bg luxy-el" data-speed-y="40">
          <bannerComponent :banner="data.banner"></bannerComponent>
        </div>
      </div>
      <div class="section02">
        <div class="bg luxy-el" data-speed-y="20"></div>
        <div class="content">
          <div class="t1">入驻单位</div>
          <div class="nr">
            <div class="l">
              <div class="types">
                <p
                  v-for="(item, index) in data.checkunit"
                  :key="index"
                  :class="{ active: tindex == index }"
                  @click="goSlide(index)"
                >
                  {{ item.title }}
                </p>
              </div>
              <div class="sw1">
                <swiper :options="swiperOption1" ref="mySwipers" class="swiper">
                  <swiper-slide
                    class="item"
                    v-for="(item, index) in data.checkunit"
                    :key="index"
                  >
                    <div class="text">
                      <p class="p1">{{ item.keywords }}</p>
                      <div class="des">
                        {{ item.description }}
                      </div>
                      <div class="more" @click="goRz">
                        <img src="../assets/jt.png" alt="" />
                        <p>了解更多</p>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <div class="btns">
                <div class="prev">
                  <img src="../assets/jh.png" alt="" />
                  <img src="../assets/jb.png" alt="" />
                </div>
                <div class="next">
                  <img src="../assets/jh.png" alt="" />
                  <img src="../assets/jb.png" alt="" />
                </div>
              </div>
            </div>
            <div class="r">
              <swiper :options="swiperOption2" ref="mySwipers2" class="swiper">
                <swiper-slide
                  class="item"
                  v-for="(item, index) in data.checkunit"
                  :key="index"
                >
                  <div class="pic">
                    <img :src="$picUrl + item.picurl" alt="" />
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
      <div class="section03">
        <div class="content">
          <div class="t1">
            <div class="l">政策文件</div>
            <!-- <div class="r">
               <a href="./news.html?tid=1" class="active">通知公告</a>
               <a href="./news.html?tid=2">新闻资讯</a>
               <a href="./news.html?tid=3">政策文件</a>
               <a href="./news.html?tid=4">行业热点</a>
             </div> -->
          </div>
          <div class="files">
            <div class="rnews">
              <p class="p1">最新文件 ——{{ data.news_2[0].posttime }}</p>
              <p class="p2">{{ data.news_2[0].title }}</p>
              <div class="btn" @click="downloadFile(data.news_2[0].id)">
                <img src="../assets/jt.png" alt="" />
                <p>查看详情</p>
              </div>
            </div>
            <div class="rnews">
              <p class="p1">最新文件 ——{{ data.news_2[1].posttime }}</p>
              <p class="p2">{{ data.news_2[1].title }}</p>
              <div class="btn" @click="downloadFile(data.news_2[1].id)">
                <img src="../assets/jt.png" alt="" />
                <p>查看详情</p>
              </div>
            </div>
          </div>
        </div>
        <div class="allNews">
          <div
            class="item"
            v-for="(item, index) in data.rnews"
            :key="index"
            @click="gotoInfo(item.id)"
          >
            <p class="p1">{{ item.day }}</p>
            <p class="p2">{{ item.year }}</p>
            <p class="p3">​{{ item.title }}</p>
            <div class="des">
              {{ item.description }}
            </div>
            <div class="btn">
              <div class="icon">
                <img src="../assets/jt.png" alt="" />
                <img src="../assets/b.png" alt="" />
              </div>
              <p>查看详情</p>
            </div>
            <div class="bg">
              <img src="../assets/newsb.png" alt="" />
                <!-- <img :src="$picUrl + item.picurl" alt="" /> -->
            </div>
          </div>
        </div>
        <div class="gd" @click="goNews">
          <p>更多动态</p>
          <img
            src="../assets/gdbf.svg"
            alt=""
            style="width: 13px; margin-left: 10px"
          />
        </div>
      </div>
      <div class="section05">
        <div class="bg luxy-el" data-speed-y="10"></div>
        <div class="content">
          <div class="t1">服务申请</div>
          <div class="t2">
              集聚企业检测资源，具备测试服务、设备共享、专业认证等相关功能，为汽车整车及零部件企业提供一站式检测服务。<br>
              组建一批服务能力强的专业科技服务机构，组团为科技型中小企业孵化壮大提供全周期、托管型、一站式优质服务。
          </div>
          <a href="/apply.html" class="more">
            <img src="../assets/jt.png" alt="" />
            <p>了解更多</p>
          </a>
          <div class="allItems">
            <div class="item" @click="goService('/apply.html')">
              <div class="d1">
                <div class="l">
                  <div class="pic">
                    <img src="../assets/fw11.png" alt="" />
                  </div>
                  <p>检测服务</p>
                </div>
                <div class="r">
                  <p class="p1">
                    集聚集群企业检测资源，打造公共检测服务平台，解决广大中小企业检测需求，
                    推动检测机构能力提升，促进新能源汽车产业创新发展
                  </p>
                  <div class="des">
                    1、设备资源开放共享<br>
2、全流程实时跟踪查询<br>
3、数据可溯源<br>
4、专业知识培训<br>
                  </div>
                </div>
              </div>
              <div class="d2">
                <img src="../assets/jt.png" alt="" />
                <p>探索更多</p>
              </div>
            </div>
            <div class="item" @click="goService('/apply2.html')">
              <div class="d1">
                <div class="l">
                  <div class="pic">
                    <img src="../assets/fw11.png" alt="" />
                  </div>
                  <p>科技服务</p>
                </div>
                <div class="r">
                  <p class="p1">
                   整合专业科技服务机构，组建企业科技服务联盟，组团为广大中小企业孵化壮大提供优质的科技服务，
                   提升科技服务业对区域科技创新和产业发展的支撑能力
                  </p>
                  <div class="des">
                    1、技术研发   <span>2、技术转移集成</span> <br>
3、标准认证   <span>4、科技咨询</span><br>
5、科技金融   <span>6、公益性科普</span><br>
7、创业孵化   <span>8、知识产权</span>
                  </div>
                </div>
              </div>
              <div class="d2">
                <img src="../assets/jt.png" alt="" />
                <p>探索更多</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section04">
        <div class="bg luxy-el" data-speed-y="5"></div>
        <div class="content">
          <div class="t1">入驻单位展示</div>
          <!-- <div class="t2">科技中介服务机构申请、政策补贴申请等窗口</div> -->
          <div class="pics">
            <div class="item" v-for="(item, index) in data.logo" :key="index">
              <img :src="$picUrl + item.picurl" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="section06" >
         <div class="bg luxy-el" data-speed-y="-4">
           <img src="../assets/dc.png" alt="">
         </div>
         <p class="p1 f30">专家库名录</p>
         <p class="p2 f60">德才兼备，以德为先；重表现、看发展</p>
         <div class="more f18">
           <img src="../assets/b.png" alt="">
           <p>探索更多</p>
         </div>
       </div> -->
      <foot-Component></foot-Component>
    </div>
  </div>
</template>

<script>
import bannerComponent from "../components/banner";
import footComponent from "../components/foot";
import Header from "../components/header";
import { getIndex } from "../util/lang";
import luxy from "luxy.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "home",
  data() {
    let _this = this;
    return {
      swiperOption1: {
        loop: true,
        init: true,
        slidesPerView: 1,
        speed: 1000,
        autoplay: false,
        spaceBetween: 50,
        navigation: {
          nextEl: ".btns .next",
          prevEl: ".btns .prev",
        },
        on: {
          slideChangeTransitionStart: function () {
            // alert(this.activeIndex);
            _this.tindex = this.realIndex;
          },
        },
      },
      swiperOption2: {
        loop: true,
        init: true,
        slidesPerView: 1,
        slideToClickedSlide: true,
        speed: 1000,
        autoplay: false,
        spaceBetween: 50,
      },
      tindex: 0,
      data: {
        banner: [],
        checkunit: [],
        logo: [],
        news_1: [],
        news_2: [{
          time:''
        },{
          time:''
        }],
        nObj: {},
        rnews: [],
      },
    };
  },
  mounted() {
    if (document.body.clientWidth > 1000) {
      luxy.init({
        wrapper: "#luxy",
        targets: ".luxy-el",
        wrapperSpeed: 0.08,
      });
    }
    this.getHome();
    this.$refs.mySwipers.swiper.init();
    this.$refs.mySwipers2.swiper.init();
    const swiperTop = this.$refs.mySwipers.swiper;
    const swiperThumbs = this.$refs.mySwipers2.swiper;
    swiperTop.controller.control = swiperThumbs;
    swiperThumbs.controller.control = swiperTop;
  },
  components: { bannerComponent, footComponent, Header, swiper, swiperSlide },
  methods: {
    goRz(){
      let index=4+parseInt(this.tindex)
      window.open('/unit.html?cid='+index,'_self')
    },
    goSlide(n) {
      this.tindex = n;
      this.$refs.mySwipers.swiper.slideToLoop(n, 1000, false);
    },
    getHome() {
      const url = `${getIndex()}`;
      this.$axios.post(url).then((res) => {
        res.data.data.news_1.forEach((item) => {
          item.time = item.posttime.substring(0, 10);
          item.year = item.posttime.substring(0, 7);
          item.day = item.posttime.substring(8, 10);
        });
        res.data.data.news_2.forEach((item) => {
          item.time = item.posttime.substring(0, 10);
          item.year = item.posttime.substring(0, 7);
          item.day = item.posttime.substring(8, 10);
        });
        this.data = res.data.data;
        if(this.data.news_2.length==0){
          this.data.news_2=[{posttime:''},{posttime:''}]
        }else if(this.data.news_2.length==1){
          this.data.news_2.push({posttime:''})
        }
        this.data.nObj = res.data.data.news_1[0];
        this.data.rnews = res.data.data.news_1.slice(0,3);
      });
    },
    gotoInfo(id) {
      const link = `/newsInfo.html?id=${id}`;
      window.open(link, "_blank");
    },
    downloadFile(id) {
      // window.open(this.$picUrl + path, "_blank");
       window.open("./policyInfo.html?id=" + id, "_self");
    },
    goService(page){
      window.open(page, "_self");
    },
    goNews() {
      const link = "/news.html";
      window.open(link, "_self");
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  #luxy {
    width: 100%;
    .section01 {
      height: 100vh;
      overflow: hidden;
    }
    .section02 {
      padding: 80px 0;
      position: relative;
      overflow: hidden;
      .bg {
        position: absolute;
        left: 0;
        top: -30vh;
        width: 100%;
        height: 100vh;
        background: url("../assets/hbg.png") no-repeat;
        background-size: cover;
        z-index: -1;
      }
      .content {
        width: 90%;
        margin-left: 5%;
        .t1 {
          color: #333333;
          font-size: 40px;
        }
        .nr {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin: 40px auto;
          align-items: center;
          .l {
            width: 48%;
            .types {
              display: flex;
              flex-wrap: wrap;
              p {
                width: 48%;
                color: #204aa9;
                opacity: 0.1;
                font-size: 80px;
                font-weight: bold;
                margin-bottom: 30px;
                transition: all 600ms;
                cursor: pointer;
              }
              .active {
                color: #c61d1e;
                opacity: 1;
              }
              p:nth-child(3),
              p:nth-child(4) {
                text-align: right;
              }
            }
            .sw1 {
              margin-top: 60px;
              .swiper {
                .item {
                  .text {
                    .p1 {
                      color: #333333;
                      font-size: 28px;
                    }
                    .des {
                      color: #666666;
                      font-weight: lighter;
                      line-height: 2.5;
                      margin: 30px 0;
                    }
                    .more {
                      display: flex;
                      align-items: center;
                      cursor: pointer;
                      p {
                        margin-left: 10px;
                        color: #c61d1e;
                        font-size: 14px;
                      }
                    }
                  }
                }
              }
            }
            .btns {
              display: flex;
              align-items: center;
              margin-top: 60px;
              .prev {
                width: 65px;
                height: 65px;
                background: #ffffff;
                border-radius: 50%;
                position: relative;
                cursor: pointer;
                transition: all 600ms;
                transform: rotateY(180deg);
                outline: none;
                img {
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                  transition: all 600ms;
                }
                img:nth-child(2) {
                  opacity: 0;
                }
                &:hover {
                  background: #c61d1e;
                  img:nth-child(1) {
                    opacity: 0;
                  }
                  img:nth-child(2) {
                    opacity: 1;
                  }
                }
              }
              .next {
                width: 65px;
                height: 65px;
                background: #ffffff;
                border-radius: 50%;
                position: relative;
                cursor: pointer;
                transition: all 600ms;
                margin-left: 30px;
                outline: none;
                img {
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                  transition: all 600ms;
                }
                img:nth-child(2) {
                  opacity: 0;
                }
                &:hover {
                  background: #c61d1e;
                  img:nth-child(1) {
                    opacity: 0;
                  }
                  img:nth-child(2) {
                    opacity: 1;
                  }
                }
              }
            }
          }
          .r {
            width: 48%;
            overflow: hidden;
            .swiper {
              width: 100%;
              .item {
                .pic {
                  overflow: hidden;
                  cursor: pointer;
                  img {
                    width: 100%;
                    display: block;
                    object-fit: cover;
                    transition: all 2s;
                  }
                  &:hover {
                    img {
                      transform: scale(1.02);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    .section03 {
      position: relative;
              margin: 80px 0 0 0;
      .content {
        width: 90%;
        margin: 0 auto;
        .t1 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .l {
            color: #333333;
            font-size: 40px;
            // font-weight: lighter;
          }
          .r {
            display: flex;
            align-items: center;
            a {
              color: #333333;
              font-size: 20px;
              font-weight: bold;
              transition: all 600ms;
              margin-left: 40px;
              &:hover {
                transform: scale(1.2);
                color: #c61d1e;
              }
            }
            .active {
              transform: scale(1.2);
              color: #c61d1e;
            }
          }
        }
        .files {
          display: flex;
          justify-content: space-between;
          margin: 40px auto;
          position: relative;
          .rnews {
            width: 48%;
            cursor: pointer;
            .p1 {
              color: #666666;
              font-size: 18px;
            }
            .p2 {
              color: #333333;
              font-size: 28px;
              font-weight: bold;
              margin: 30px 0 40px 0;
                overflow:hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .btn {
              display: flex;
              align-items: center;
              cursor: pointer;
              p {
                margin-left: 10px;
                color: #c61d1e;
              }
            }
          }
        }
      }
      .allNews {
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin: 60px 0;
        overflow: hidden;
        .item {
          width: 24%;
          border-top: 1px solid #c8c8c8;
          padding: 60px 5%;
          position: relative;
          border-bottom: 1px solid #c8c8c8;
          cursor: pointer;
          .bg {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: -1;
            transition: all 600ms;
            opacity: 0;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          // &::after{
          //   content:'';
          //   display: block;
          //   position: absolute;
          //   left:0%;
          //   top:0;
          //   width:100%;
          //   height:100%;
          //   background: rgba($color: #000000, $alpha: .5);
          //   z-index: -1;
          //   opacity: 0;
          //   transition: all 600ms;
          // }
          .p1 {
            color: #b9b9b9;
            font-size: 50px;
            font-weight: bold;
            transition: all 600ms;
          }
          .p2 {
            color: #666666;
            font-weight: bold;
            margin-top: 10px;
            transition: all 600ms;
          }
          .p3 {
            color: #333333;
            font-size: 20px;
            font-weight: bold;
            margin: 30px 0;
            transition: all 600ms;
          }
          .des {
            color: #666666;
            line-height: 1.8;
            transition: all 600ms;
          }
          .btn {
            display: flex;
            align-items: center;
            margin-top: 40px;
            transition: all 600ms;
            color: #c61d1e;
            .icon {
              position: relative;
              img {
                transition: all 600ms;
              }
              img:nth-child(2) {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                opacity: 0;
              }
            }
            p {
              margin-left: 10px;
            }
          }
          &:hover {
            // &::after{
            //   opacity: 1;
            // }
            .bg {
              opacity: 1;
            }
            .p1,
            .p2,
            .p3,
            .des,
            .btn {
              color: white;
            }
            .btn {
              .icon {
                img:nth-child(1) {
                  opacity: 0;
                }
                img:nth-child(2) {
                  opacity: 1;
                }
              }
            }
          }
        }
      }
      .gd {
        display: flex;
        justify-content: center;
        margin-bottom: 60px;
        cursor: pointer;
        p {
          color: #c61d1e;
          font-size: 18px;
        }
      }
    }
    .section04 {
      width: 100%;
      position: relative;
      overflow: hidden;
      padding: 200px 0;
      .bg {
        position: absolute;
        left: 0;
        top: -50vh;
        width: 100%;
        height: 120vh;
        background: url("../assets/ltbg.png") no-repeat;
        background-size: cover;
        z-index: -1;
      }
      .content {
        width: 80%;
        margin: 0 auto;
        color: white;
        .t1 {
          text-align: center;
          font-size: 40px;
        }
        .t2 {
          text-align: center;
          font-weight: lighter;
          margin-top: 20px;
        }
        .pics {
          display: flex;
          flex-wrap: wrap;
          margin-top: 60px;
          .item {
            width: 20%;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
            // overflow: hidden;
            img {
              width: 180px;
              height: 100px;
              object-fit: contain;
              transition: all 600ms;
            }
            &:hover {
              img {
                transform: scale(1.1);
              }
            }
          }
        }
      }
    }
    .section05 {
      width: 100%;
      position: relative;
      overflow: hidden;
      padding: 20vh 0;
      .bg {
        position: absolute;
        left: 0;
        top: -60%;
        width: 100%;
        height: 120%;
        background: url("../assets/fwbg.png") no-repeat;
        background-size: cover;
        z-index: -1;
      }
      .content {
        width: 90%;
        margin: 0 auto;
        .t1 {
          color: #333333;
          font-size: 40px;
        }
        .t2 {
          color: #333333;
          line-height: 2;
          margin-top: 30px;
        }
        .more {
          display: flex;
          align-items: center;
          margin-top: 60px;
          p {
            color: #c61d1e;
            margin-left: 10px;
            font-weight: lighter;
          }
        }
        .allItems {
          margin-top: 400px;
          display: flex;
          justify-content: space-between;
          .item {
            width: 48%;
            background: url("../assets/fw1.png") no-repeat;
            background-size: cover;
            cursor: pointer;
            .d1 {
              display: flex;
              justify-content: space-between;
              border-bottom: 1px solid #eeeeee;
              .l {
                width: 30%;
                text-align: center;
                border-right: 1px solid #eeeeee;
                padding-top: 80px;
                .pic {
                  width: 84px;
                  height: 84px;
                  background: #c61d1e;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin: 0 auto;
                }
                p {
                  color: #333333;
                  font-size: 23px;
                  margin-top: 15px;
                }
              }
              .r {
                width: 60%;
                padding: 80px 5%;
                .p1 {
                  color: #333333;
                  font-size: 20px;
                  line-height: 1.7;
                }
                .des {
                  color: #666666;
                  // font-weight: lighter;
                  margin-top: 20px;
                  line-height: 2;
                  // height: 96px;
                  // overflow: hidden;
                  // text-overflow: ellipsis;
                  // display: -webkit-box;
                  // -webkit-line-clamp: 4;
                  // -webkit-box-orient: vertical;
                                span{
                margin-left: 30px;
              }
                }
              }
            }
            .d2 {
              width: 80%;
              margin: 20px auto;
              display: flex;
              align-items: center;
              p {
                color: #999999;
                font-size: 18px;
                margin-left: 20px;
              }
            }
          }
        }
      }
    }
    .section06 {
      padding: 200px 0;
      text-align: center;
      color: white;
      position: relative;
      width: 100%;
      .bg {
        position: absolute;
        left: 0;
        top: 50%;
        width: 100%;
        height: 130%;
        z-index: -1;
        img {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
        }
      }
      .p2 {
        margin: 15px 0;
      }
      .more {
        margin-top: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        p {
          margin-left: 10px;
        }
      }
    }
  }
  @media screen and (max-width: 1500px) {
    #luxy {
      .section02 {
        .content {
          .nr {
            .l {
              .types {
                p {
                  font-size: 60px;
                }
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1000px) {
    #luxy {
      .section02 {
        padding: 30px 0;
        .bg {
          top: 0;
          height: 100%;
        }
        .content {
          width: 90%;
          margin: 0 auto;
          .t1 {
            font-size: 24px;
          }
          .nr {
            flex-direction: column;
            margin: 20px auto;
            .l {
              width: 100%;
              .types {
                p {
                  width: 25%;
                  font-size: 18px;
                  margin-bottom: 0;
                }
              }
              .sw1 {
                margin-top: 30px;
                .swiper {
                  .item {
                    .text {
                      .p1 {
                        font-size: 20px;
                      }
                      .des {
                        margin: 15px 0;
                        line-height: 2;
                      }
                    }
                  }
                }
              }
              .btns {
                margin-top: 30px;
              }
            }
            .r {
              width: 100%;
              margin-top: 30px;
            }
          }
        }
      }
      .section03 {
        margin-top: 30px;
        .content {
          margin: 40px auto;
          .t1 {
            flex-direction: column;
            .l {
              font-size: 24px;
            }
            .r {
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
              width: 100%;
              a {
                font-size: 16px;
                margin-left: 0;
              }
            }
          }
          .files{
            flex-direction: column;
            .rnews{
              width:100%;
              .p2{
                margin: 15px 0;
                font-size: 20px;
              }
            }
          }
          .rnews {
            margin: 20px auto;
            .p2 {
              font-size: 18px;
              margin: 15px 0;
            }
          }
        }
        .allNews {
          margin: 30px 0;
          flex-direction: column;
          .item {
            width: 90%;
            padding: 30px 5%;
            .p1 {
              font-size: 24px;
            }
            .p3 {
              font-size: 18px;
              margin: 15px 0;
            }
            .btn {
              margin-top: 20px;
            }
          }
        }
      }
      .section04 {
        padding: 50px 0;
        .bg {
          top: 0;
          height: 100%;
        }
        .content {
          width: 90%;
          .t1 {
            font-size: 24px;
          }
          .pics {
            margin-top: 30px;
            .item {
              width: 33.3%;
              height: 50px;
              img {
                max-height: 50px;
              }
            }
          }
        }
      }
      .section05 {
        padding: 40px 0;
        .bg {
          top: 0;
          height: 100%;
        }
        .content {
          .t1 {
            font-size: 24px;
          }
          .t2 {
            margin-top: 15px;
          }
          .more {
            margin-top: 30px;
          }
          .allItems {
            margin-top: 40px;
            flex-wrap: wrap;
            .item {
              width: 100%;
              margin-bottom: 20px;
              .d1 {
                flex-direction: column;
                text-align: center;
                .l {
                  width: 100%;
                  border-right: none;
                  padding-top: 30px;
                }
                .r {
                  width: 90%;
                  padding: 30px 5%;
                  .p1 {
                    font-size: 18px;
                  }
                  .des {
                    margin-top: 10px;
                  }
                }
              }
            }
          }
        }
      }
      .section06 {
        padding: 30px 0;
        .bg {
          top: 0;
          height: 100%;
        }
        .p1 {
          font-size: 18px;
        }
        .p2 {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
